/**
 * @module websocket.event.handlers.aircraft.aircraft-added
 */
import { store } from '../../../../state/store'
import { setAircraftListUpdated } from '../../../../state/websocket.slice'

export default function handleAircraftAdded(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleAircraftAdded', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setAircraftListUpdated(data))
  }
} 